import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import RaisedButton from 'material-ui/RaisedButton';

import { updateProduct } from '../../actions/productActions';

class ToggleDisableStatus extends Component {
  state = {
    active: false,
  }

  componentWillMount() {
    this.setState({
      active: this.props.active
    });
  }


  _handleSubmit = event => {
    event.preventDefault();

    this.props.updateProduct({
      data: {
        is_active: !this.state.active,
      },
      key: this.props.id
    }).then(_ => {
      if (this.props.productToUpdate.status === 'updated') {
        this.setState({
          active: !this.state.active,
        })
      }
    })

  }



  render(){
    return(
      <form style={{ display: 'inline-block' }} onSubmit={this._handleSubmit}>
        { this.state.active &&
          <RaisedButton type="submit" label="Disable" buttonStyle={{lineHeight: '28px'}} style={{height: '28px'}} labelStyle={{height: 'auto'}} backgroundColor="#FFC107" />
        }
        { !this.state.active &&
          <RaisedButton type="submit" label="Enable" buttonStyle={{lineHeight: '28px'}} style={{height: '28px'}} labelStyle={{height: 'auto', color: 'white'}} backgroundColor="#009688" />
        }
      </form>

    )
  }
}


const mapStateToProps = state => ({ productToUpdate: state.product.updated });
const mapDispatchToProps = { updateProduct };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ToggleDisableStatus));



// WEBPACK FOOTER //
// ./src/components/Products/ToggleDisableStatus.js